var map = {
	"./logo-alphabet.svg": 1360,
	"./logo-amazon-2.svg": 1361,
	"./logo-amazon.svg": 1362,
	"./logo-azercell.svg": 1363,
	"./logo-bank-of-america.svg": 1364,
	"./logo-barclays.svg": 1365,
	"./logo-bbc.svg": 1366,
	"./logo-bnp-paribas.svg": 1367,
	"./logo-booking.svg": 1368,
	"./logo-citibank.svg": 1369,
	"./logo-coca-cola-white.svg": 1580,
	"./logo-coca-cola.svg": 1370,
	"./logo-deloitte.svg": 1371,
	"./logo-experian.svg": 1372,
	"./logo-facebook.svg": 1373,
	"./logo-g.svg": 1581,
	"./logo-goldman-sachs-new.svg": 1374,
	"./logo-goldman-sachs.svg": 1582,
	"./logo-google-new.svg": 1375,
	"./logo-google.svg": 1376,
	"./logo-h.svg": 1377,
	"./logo-henkel.svg": 1378,
	"./logo-hsbc-new.svg": 1379,
	"./logo-hsbc.svg": 1583,
	"./logo-ikea-new.svg": 1380,
	"./logo-ikea.svg": 1584,
	"./logo-infineon.svg": 1381,
	"./logo-instagram.svg": 1382,
	"./logo-jp-morgan.svg": 1383,
	"./logo-jti.svg": 1384,
	"./logo-linkedin.svg": 1385,
	"./logo-meta-new.svg": 1386,
	"./logo-meta.svg": 1585,
	"./logo-morgan-stanley-new.svg": 1387,
	"./logo-morgan-stanley.svg": 1586,
	"./logo-netflix.svg": 1587,
	"./logo-oracle.svg": 1388,
	"./logo-paypal.svg": 1389,
	"./logo-pwc-new.svg": 1390,
	"./logo-pwc.svg": 1588,
	"./logo-spotify.svg": 1589,
	"./logo-tesla.svg": 1391,
	"./logo-visa.svg": 1392,
	"./logo-walmart.svg": 1393,
	"./logo-youtube.svg": 1394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1547;